export const SERVICES = [
  {
    slug: 'growth-marketing-enablement',
    name: 'Growth Marketing Enablement',
    tagline: 'Build a more predictable growth system.',
    problem: 'Inconsistent lead flow, unclear targeting, weak outbound, untracked advertising, poor follow-up, and limited visibility over CAC and conversion.',
    components: [
      'Growth and sales audit',
      'ICP definition',
      'ABM lead list building',
      'Outbound email setup',
      'LinkedIn outreach',
      'Paid media strategy and execution',
      'Retargeting and matched audiences',
      'Content and nurture systems',
      'Conversion tracking',
      'Landing page optimisation',
      'CAC and CPL visibility',
      'Growth reporting',
    ],
    outcome: 'A working growth system with a clear ICP, measurable channels, and reliable follow-up — not disconnected campaigns.',
    cta: 'Book a Growth Systems Audit',
    ctaUrl: '/audit',
    seoTitle: 'Growth Marketing Enablement for South African Businesses',
    dosStage: 'Attract',
  },
  {
    slug: 'digital-commerce-enablement',
    name: 'eCommerce Enablement',
    tagline: 'Build a stronger eCommerce system.',
    problem: 'Businesses want to sell online but their storefront, payments, marketplace setup, and customer journeys are often disconnected or incomplete.',
    components: [
      'Ecommerce strategy',
      'Store design and setup',
      'Product setup',
      'Payments and delivery',
      'Marketplace readiness',
      'Conversion optimisation',
      'Customer journey design',
      'Customer service workflows',
      'Lead capture and follow-up',
    ],
    outcome: 'A commerce system where your storefront and marketplaces work together — supporting discovery, sales, service and follow-up.',
    cta: 'Book an eCommerce Audit',
    ctaUrl: '/audit',
    seoTitle: 'eCommerce Enablement Services',
    dosStage: 'Sell / Serve',
  },
  {
    slug: 'aws-cloud-enablement',
    name: 'AWS Cloud Enablement',
    tagline: 'Build the cloud foundation behind your growth.',
    problem: 'As businesses grow, their systems often become harder to maintain, less secure, more expensive, and less reliable. What they need is a clear cloud strategy, not just more software.',
    components: [
      'Cloud readiness assessment',
      'AWS migration',
      'Cloud architecture',
      'Application hosting',
      'Infrastructure optimisation',
      'Cost optimisation',
      'Security and access controls',
      'Backup and resilience',
      'Amazon Connect and contact centre modernisation',
      'AI-ready cloud infrastructure',
    ],
    outcome: 'A cloud foundation that reduces risk and cost while making growth, automation and AI adoption realistic.',
    cta: 'Book a Cloud Readiness Assessment',
    ctaUrl: '/audit',
    seoTitle: 'AWS Cloud Enablement Services for Businesses',
    dosStage: 'Scale',
  },
];

export function getServiceBySlug(slug) {
  return SERVICES.find((s) => s.slug === slug);
}
